import { useContext, useEffect, useRef, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
// import "react-multi-carousel/lib/styles.css";
import Notiflix from "notiflix";
import { Select, Space } from "antd";
import Form from "react-bootstrap/Form";
import { FaSearch } from "react-icons/fa";
import { IoFilter } from "react-icons/io5";
import { LuVegan } from "react-icons/lu";
import Carousel from "react-multi-carousel";
import { Link, useLocation, useNavigate } from "react-router-dom";
import QuickSelection from "../../../../Components/OnlineOrdering/QuickSelection/QuickSelection.js";
import "./Shop.css";
import { RiEBike2Line } from "react-icons/ri";
import { TbInfoSquare, TbPaperBag } from "react-icons/tb";
import PostApiCall from "../../helper/PostAPI.js";
import NewAddTocart from "../../../Buttons/NewAddTocart.js";
import ModifyQuantity from "../../../Buttons/ModifyQuantity.js";
import { newstore } from "./Store/newStore.js";
import GetSeoData from "../../../Helpers/GetSeoData.js";

export const ShopNew = () => {
  const navigate = useNavigate();
  const { cartItems, storeStatus, setLoginModalStatus, setModalSide } =
    useContext(newstore);

  const scrollRef = useRef(null);
  const [scroll, setScroll] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const pageLocation = useLocation();
  const [cuisines, setcuisines] = useState([]);
  const [allcuisines, setallcuisines] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [active, setActive] = useState("All");
  const [filterOffcanvas, setFilterOffcanvas] = useState(false);
  const [filterTypes, setfilterTypes] = useState([]);
  let count = 0;
  const [keyStrings, setKeyStrings] = useState([]);
  const [restaurantName, setRestaurantName] = useState(null);
  const [bannerDetails, setbannerDetails] = useState([]);

  const [categories, setCategories] = useState([]);
  const [selectCat, setSelectedCat] = useState("");
  const [allProductList, setAllProductList] = useState([]);
  const [productList, setProductList] = useState([]);

  const offerBanners = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  useEffect(() => {
    const handleScroll = () => {
      if (pageLocation.pathname === "/shop") {
        setScrolled(window.scrollY > 200);
      }
    };

    if (pageLocation.pathname === "/shop") {
      window.addEventListener("scroll", handleScroll);
    }

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [pageLocation]);

  useEffect(() => {
    Notiflix.Loading.Circle();

    PostApiCall.postRequest(
      {
        catCount: "*",
      },
      "GetProductVertical"
    ).then((results) =>
      results?.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          setSelectedCat(obj1.data[0]?.fld_verticlename);
          setCategories(obj1.data.filter((dat) => dat.fld_status === "Active"));
          Notiflix.Loading.Remove();
          GetAllItems(obj1.data[0].selected_cat_id);
        }
      })
    );
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const GetAllItems = (id) => {
    Notiflix.Loading.Circle();

    PostApiCall.postRequest(
      {
        // categoryid: id ? id : null,
        stateid: null,
      },
      "Get_All_Items"
    )
      // PostApiCall.postRequest({}, "GetAllItems")
      .then((res) => res.json())
      .then((resData) => {
        if (resData?.data?.length > 0) {
          setProductList(resData.data);
          setAllProductList(resData.data);
        }
        Notiflix.Loading.Remove();
      });
  };

  const searchpProduct = (value) => {
    let searchedData = allProductList;
    if (value) {
      searchedData = searchedData?.filter((det) => {
        const valuesToSearch =
          det?.fld_variantname?.trim()?.toLowerCase() +
          det?.fld_categoryname?.trim()?.toLowerCase();
        return valuesToSearch?.includes(value?.trim()?.toLowerCase());
      });
    }
    setProductList(searchedData);
  };

  return (
    <div className="order-online-page overflow-hidden">
      <GetSeoData type="Shop" />
      <section className="offer-banner mt-5">
        <Container fluid>
          <Row>
            <h2
              className="text-center"
              dangerouslySetInnerHTML={{
                __html:
                  keyStrings?.filter(
                    (item) => item.FLD_Key_Name == "HOME_PAGE_WELCOME_TO"
                  )[0] != null
                    ? keyStrings?.filter(
                        (item) => item.FLD_Key_Name == "HOME_PAGE_WELCOME_TO"
                      )[0].FLD_Key_Value +
                      " " +
                      restaurantName
                    : "<div></div>",
              }}></h2>
            <p
              className="text-center mb-0"
              dangerouslySetInnerHTML={{
                __html:
                  keyStrings?.filter(
                    (item) => item.FLD_Key_Name == "HOME_PAGE_SUB_HEADING"
                  )[0] != null
                    ? keyStrings?.filter(
                        (item) => item.FLD_Key_Name == "HOME_PAGE_SUB_HEADING"
                      )[0].FLD_Key_Value
                    : "<div></div>",
              }}></p>
            <p
              className="text-center pb-3"
              dangerouslySetInnerHTML={{
                __html:
                  keyStrings?.filter(
                    (item) =>
                      item.FLD_Key_Name == "HOME_PAGE_SUB_HEADING_LINE_2"
                  )[0] != null
                    ? keyStrings?.filter(
                        (item) =>
                          item.FLD_Key_Name == "HOME_PAGE_SUB_HEADING_LINE_2"
                      )[0].FLD_Key_Value
                    : "<div></div>",
              }}></p>
          </Row>
          {bannerDetails != "undefined" && bannerDetails?.length != 0 ? (
            <Carousel
              swipeable={true}
              draggable={true}
              showDots={true}
              responsive={offerBanners}>
              {bannerDetails?.length != 0 ? (
                bannerDetails
                  ?.filter((dat) => dat.fld_banner_status == "Yes")
                  .map((data) => {
                    console.log(data);
                    return (
                      <div className="text-center mx-lg-1 mx-1">
                        <div className="offer-image-inner-banner">
                          <img alt={data.fld_alt} src={data.fld_banner_image} />
                        </div>
                      </div>
                    );
                  })
              ) : (
                <></>
              )}
            </Carousel>
          ) : (
            ""
          )}
        </Container>
      </section>
      {/* <QuickSelection /> */}
      <section
        className={scroll ? "sticky-search-bar shadow-sm mt-0 pb-1" : "mt-2"}>
        <Container
          fluid
          style={{
            marginTop: `${
              pageLocation.pathname === "/shop" && scrolled ? "0" : "50px"
            }`,
          }}>
          <Card className={scroll ? "" : "shadow-search"}>
            <Card.Body className="py-0 pe-0">
              <Row className="align-items-center w-100 me-1">
                <Col
                  lg={6}
                  className="pb-3 pt-lg-3 pe-0 d-flex justify-content-between align-content-center gap-2">
                  <div className="flex-div position-relative">
                    {/* <Form> */}
                    <Form.Control
                      type="text"
                      value={searchText}
                      onFocus={() => {
                        setcuisines(allcuisines);
                      }}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                        searchpProduct(e.target.value);
                        // const query = e.target.value.toLowerCase();

                        // if (query.length === 0) {
                        // 	setcuisines([]);
                        // } else {
                        // 	setcuisines(
                        // 		allcuisines.filter((product) =>
                        // 			product.search_field
                        // 				?.toLowerCase()
                        // 				.includes(query)
                        // 		)
                        // 	);
                        // }
                      }}
                      placeholder="Search for a dish"
                    />

                    <FaSearch className="search-icon" />
                    {/* </FloatingLabel> */}
                    {/* </Form> */}
                  </div>
                </Col>
                <Col lg={6} className="pe-0">
                  <Row className="food-type-filter-row">
                    <button
                      className={`item-category-filter all ${
                        active == "All" && "active"
                      }`}
                      onClick={() => {
                        setActive("All");
                        setcuisines(allcuisines);
                        setSearchText("");
                        if (window.innerWidth < 568) {
                          setFilterOffcanvas(true);
                        }
                      }}>
                      {/* All Items */}
                      {/* <BsFilterSquareFill /> */}
                      <IoFilter />
                    </button>
                    {filterTypes?.map((data) => {
                      return (
                        <>
                          <button
                            key={data.fld_id}
                            type="button"
                            className={`item-category-filter veg ${
                              active == data.fld_filter_type ? "active" : ""
                            }`}
                            onClick={() => {
                              setActive(data.fld_filter_type);
                              const removeFav = allcuisines;
                              setcuisines(
                                removeFav.filter(
                                  (product) =>
                                    product.FLD_Food_Type ==
                                      data.fld_filter_type ||
                                    product.best_seller ==
                                      data.fld_filter_type ||
                                    product.contains_egg == data.fld_filter_type
                                )
                              );
                              setSearchText("");
                            }}>
                            <img
                              src={data.fld_image}
                              alt={data.fld_label}
                              className="recipe-type-image"
                            />
                            {/* <GiPlainCircle /> */}
                            {data.fld_label}
                          </button>
                        </>
                      );
                    })}
                    <Space className="order-online-sort">
                      <Select
                        defaultValue="Sort by"
                        onChange={(value) => {
                          const sortedItems = [...productList];

                          if (value === "Price, High to Low") {
                            sortedItems.sort(
                              (a, b) =>
                                b.fld_website_discount_price -
                                a.fld_website_discount_price
                            );
                          } else if (value === "Price, Low to High") {
                            sortedItems.sort(
                              (a, b) =>
                                a.fld_website_discount_price -
                                b.fld_website_discount_price
                            );
                          }
                          setProductList(sortedItems);
                          // setcuisines(sortedItems);
                        }}
                        options={[
                          {
                            value: "Price, High to Low",
                            label: "Price, High to Low",
                          },
                          {
                            value: "Price, Low to High",
                            label: "Price, Low to High",
                          },
                        ]}
                      />
                    </Space>
                    <button
                      style={{ display: count > 0 ? "block" : "none" }}
                      className={`item-category-filter vegan ${
                        active == "Vegan" && "active"
                      }`}
                      onClick={() => {
                        setActive("Vegan");
                        const removeFav = allcuisines;
                        setcuisines(
                          removeFav.filter((product) => {
                            if (product.FLD_Food_Type === "Vegan") {
                              count++;
                              return product;
                            } else {
                              return false;
                            }
                          })
                        );
                        setSearchText("");
                      }}>
                      <LuVegan />
                      Vegan
                    </button>
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Container>
      </section>
      <section class="mt-md-4">
        <div class="container-fluid">
          <div class="mx-0 oder-online-category" data-category-columns="2">
            {categories?.map((cat, i) => {
              return (
                <div
                  class="oder-online-category-card"
                  onClick={() => {
                    navigate(`/category/${cat?.fld_route}`);
                    // const section = document.getElementById(cat?.selected_cat_id);
                    // if (section) {
                    // 	section.scrollIntoView({ behavior: "smooth" });
                    // }
                    // setSelectedCat(cat?.fld_verticlename)
                    // GetAllItems(cat?.selected_cat_id)
                  }}>
                  <div class="text-center mx-lg-2 mx-0 cursor-pointer">
                    <div class="item-image category-box">
                      <img
                        class="img-fluid"
                        src={cat?.fld_verticalImage}
                        alt={cat?.fld_verticlename}
                      />
                    </div>
                    <p class="item-name">{cat?.fld_verticlename}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {categories?.map((cat, i) => {
        const listData = productList?.filter(
          (item) => item?.fld_categoryid === cat?.selected_cat_id
        );
        return (
          <>
            <section
              className="mt-md-4 mb-4"
              key={cat?.selected_cat_id}
              id={cat?.selected_cat_id}>
              <div className="sticky-top-category-heading d-flex align-items-center px-4">
                <h2>{cat?.fld_verticlename}</h2>
              </div>
              <Container fluid={true}>
                <Row>
                  {listData?.map((det, i) => {
                    const isCart = cartItems.find((val) => {
                      if (val.fld_variantid === det.fld_variantid) {
                        return det;
                      }
                      return false;
                    });

                    const shortDescriptions = det?.fld_short_description.slice(
                      0,
                      130
                    );

                    return (
                      <Col
                        md={6}
                        xl={4}
                        className="item-card-wrapper p-3"
                        key={i}>
                        <div
                          className="item-card"
                          onClick={() => {
                            navigate(`/product/${det.fld_route}`);
                          }}>
                          <div className="recipe-img-wrapper recipe-img-wrapper-tab-view">
                            <Link to={"/shop"}>
                              <img
                                className="recipe-img order-lg-1 order-2"
                                src={det?.VariantImage}
                                alt={det?.fld_variantname}
                              />
                            </Link>
                          </div>
                          <div className="w-100 px-lg-3 ps-3 order-lg-2 order-1">
                            <p className="recipe-best mb-3">
                              <img
                                alt="best-seller"
                                className="recipe-type"
                                src="https://globaltrendz.online/GrubDigestCDN/Images/veg_icon.png"
                              />
                              <span className="best-seller">Best Seller</span>
                            </p>
                            <h6>
                              <Link to={"/shop"}>{det?.fld_variantname}</Link>
                            </h6>
                            <p className="recipe-category">
                              <span>{det?.fld_categoryname}</span>
                            </p>
                            <p
                              className="recipe-description d-none d-lg-block"
                              dangerouslySetInnerHTML={{
                                __html:
                                  det?.fld_short_description?.length > 130
                                    ? shortDescriptions + "..."
                                    : det?.fld_short_description || "",
                              }}
                            />
                          </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mt-2">
                          <div className="d-flex align-items-center gap-2">
                            <span>
                              <RiEBike2Line
                                className="wishlist-share"
                                title="Delivery"
                              />
                            </span>
                            <span>
                              <TbPaperBag
                                className="wishlist-share"
                                title="TakeAway"
                              />
                            </span>
                            <span>
                              <TbInfoSquare
                                className="wishlist-share cursor-pointer"
                                title="Read More"
                              />
                            </span>
                          </div>

                          <div className="d-flex gap-2 align-items-center">
                            <h6 className="recipe-price">
                              <span>Rs</span> {det?.fld_website_discount_price}
                            </h6>
                            {isCart ? (
                              <ModifyQuantity
                                itemid={det?.fld_variantid}
                                quantity={isCart.fld_quantity}
                                cartlineid={isCart.fld_cart_dtl_id}
                              />
                            ) : (
                              <span className="theme-btn cursor-pointer">
                                <NewAddTocart itemid={det?.fld_variantid} />
                              </span>
                            )}
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </Container>
            </section>
          </>
        );
      })}

      <section className="fixed-bottom mb-0 ms-auto px-2">
        <div>
          <>
            <div className="d-flex flex-wrap flex-lg-nowrap justify-content-end align-items-center py-2">
              {cartItems?.length > 0 && (
                <Button
                  variant="danger"
                  size="lg"
                  className={
                    cartItems?.length > 0
                      ? "floating-button-cart floating-button-cart-btn d-flex"
                      : "floating-button-cart d-flex"
                  }
                  onClick={() => {
                    navigate("/cart");
                  }}>
                  <div>
                    <p className="mb-0 total-item-amount d-flex">
                      {cartItems?.length} Item
                      <span
                        style={{
                          display: cartItems?.length == 1 ? "none" : "block",
                        }}>
                        (s)
                      </span>
                      &nbsp; | ₹ {cartItems[0]?.fld_cart_amount_no_shipping}{" "}
                      Plus Taxes
                    </p>
                  </div>
                </Button>
              )}
            </div>
          </>
        </div>
      </section>
    </div>
  );
};
